import { render, staticRenderFns } from "./FrequencyEditTab.vue?vue&type=template&id=3a546dbb&scoped=true"
import script from "./FrequencyEditTab.vue?vue&type=script&lang=js"
export * from "./FrequencyEditTab.vue?vue&type=script&lang=js"
import style0 from "./FrequencyEditTab.vue?vue&type=style&index=0&id=3a546dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a546dbb",
  null
  
)

export default component.exports